
export const validateEmail = (email) => {
  const isValid = email.length > 0;

  return isValid;
}